// TODO: Create a registration page using "githubDB" (https://github.com/usmakestwo/githubDB) or Google Forms.

import Form from "../components/Form";

export default function Registry() {
	return (
		<main>
			<div className="container">
				<Form />
			</div>
		</main>
	);
}
